import contentStringsEn from "./contentStringsEn";

// stageContent.js
const stageContent = {
  0: {
    title: "Introduction",
    content: contentStringsEn.stage0,
    //avatar: `${process.env.PUBLIC_URL}/avatar0.png`,
    image: `${process.env.PUBLIC_URL}/stage0.png`,
    videoSrc: `https://youtu.be/mim19S1lQ8E`,
  },
  1: {
    title: "Noticing Changes",
    content: contentStringsEn.stage1,
    //avatar: `${process.env.PUBLIC_URL}/avatar1.png`,
    image: `${process.env.PUBLIC_URL}/stage1.png`,

    videoSrc: `https://youtu.be/8ndGYPNESGQ`,
  },
  2: {
    title: "Adjusting +/- Diagnosis",
    content: contentStringsEn.stage2,
    // avatar: `${process.env.PUBLIC_URL}/avatar2.png`,
    image: `${process.env.PUBLIC_URL}/stage2.png`,
    videoSrc: `https://youtu.be/XKr_g8NTDD0`,
  },
  3: {
    title: "Shifting Responsibilities",
    content: contentStringsEn.stage3,
    //avatar: `${process.env.PUBLIC_URL}/avatar3.png`,
    image: `${process.env.PUBLIC_URL}/stage3.png`,
    videoSrc: `https://youtu.be/ITVPdU8bLU4`,
  },
  4: {
    title: "Full Time Care",
    content: contentStringsEn.stage4,
    //avatar: `${process.env.PUBLIC_URL}/avatar4.png`,
    image: `${process.env.PUBLIC_URL}/stage4.png`,
    videoSrc: `https://youtu.be/kcbAMXZuUA0`,
  },
  5: {
    title: "End of Life",
    content: contentStringsEn.stage5,
    // avatar: `${process.env.PUBLIC_URL}/avatar5.png`,
    image: `${process.env.PUBLIC_URL}/stage5.png`,
    videoSrc: `https://youtu.be/ahNO5sLd4c4`,
  },
  6: {
    title: "Finding Meaning",
    content: contentStringsEn.stage6,
    //avatar: `${process.env.PUBLIC_URL}/avatar6.png`,
    image: `${process.env.PUBLIC_URL}/stage6.png`,
    videoSrc: `https://youtu.be/Pnk05hiKNAE`,
  },
  7: {
    title: "Essential Tips for Raregivers",
    content: contentStringsEn.stage7,
    image: `${process.env.PUBLIC_URL}/stage7.png`,
    //avatar: `${process.env.PUBLIC_URL}/avatar7.png`,
    videoSrc: `https://youtu.be/uLwkawLmOXg`,
  },
};

export default stageContent;
